export const isInactiveStaffing = (s) =>
  s?.status === "removed" || s?.status === "unavailable";

export const isConfirmedStaffing = (s) =>
  !isInactiveStaffing(s) &&
  (s?.status === "confirmed" ||
    s?.application_status === "accepted" ||
    s?.invite_status === "confirmed");

export const isPendingApplication = (s) =>
  !isInactiveStaffing(s) &&
  s?.application_status === "pending" &&
  s?.status !== "confirmed" &&
  s?.invite_status !== "confirmed";

// Application acceptance reserves a place; only an invite response confirms dates.
export const getScheduleDateStatus = (staffing) => ({
  asked: Boolean(staffing?.invite_sent || ['sent', 'confirmed', 'declined'].includes(staffing?.invite_status)),
  accepted: staffing?.invite_status === 'confirmed' ? 'confirmed'
    : staffing?.invite_status === 'declined' ? 'declined'
    : staffing?.invite_status === 'sent' || staffing?.invite_sent ? 'pending' : null,
});
